/* ==========================================================================
   Voile Chic — trust badge info popovers
   The popover opens above the badge, or below it when there is not enough
   room above — the badges sit inside a scrolling column, so one near the top
   edge used to be clipped.
   ========================================================================== */

(function () {
  var INFO_ICON =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"></circle><path d="M12 16v-4"></path><path d="M12 8h.01"></path></svg>';

  function cfg() {
    var el = document.getElementById('vc-cro-config');
    return el ? el.dataset : {};
  }

  function closeAll(except) {
    var open = document.querySelectorAll('.vc-badge__pop.is-open');
    for (var i = 0; i < open.length; i++) {
      if (open[i] !== except) open[i].classList.remove('is-open');
    }
  }

  /* Flip below the badge when the popover would be cut off above it. */
  function position(pop, badge) {
    pop.classList.remove('is-below');

    var scroller = badge.closest('.wt-cart__drawer__body, .product__info-container, .wt-product__info');
    var limit = scroller ? scroller.getBoundingClientRect().top : 0;
    var needed = pop.offsetHeight + 14;

    if (badge.getBoundingClientRect().top - needed < limit) {
      pop.classList.add('is-below');
    }
  }

  function build() {
    var row = document.querySelector('.vc-badges');
    if (!row || row.dataset.vcInfo) return false;

    var d = cfg();
    var notes = [d.badge1Info || '', d.badge2Info || '', d.badge3Info || ''];
    var badges = row.querySelectorAll('.vc-badge');
    if (!badges.length) return false;

    row.dataset.vcInfo = '1';

    for (var i = 0; i < badges.length; i++) {
      var note = (notes[i] || '').trim();
      if (!note || note === '-') continue;

      var badge = badges[i];
      var label = badge.querySelector('span');
      if (!label) continue;

      var wrap = document.createElement('span');
      wrap.className = 'vc-badge__labelrow';
      label.parentNode.insertBefore(wrap, label);
      wrap.appendChild(label);

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'vc-badge__info';
      btn.innerHTML = INFO_ICON;
      btn.setAttribute('aria-label', 'More information');
      btn.setAttribute('aria-expanded', 'false');
      wrap.appendChild(btn);

      var pop = document.createElement('span');
      pop.className = 'vc-badge__pop';
      pop.setAttribute('role', 'tooltip');
      pop.textContent = note;
      badge.appendChild(pop);

      (function (button, popover, host) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();

          var open = popover.classList.contains('is-open');
          closeAll(popover);

          if (open) {
            popover.classList.remove('is-open');
            button.setAttribute('aria-expanded', 'false');
            return;
          }

          /* Measure before showing, then decide which side to sit on. */
          popover.style.visibility = 'hidden';
          popover.classList.add('is-open');
          position(popover, host);
          popover.style.visibility = '';
          button.setAttribute('aria-expanded', 'true');
        });
      })(btn, pop, badge);
    }

    return true;
  }

  document.addEventListener('click', function () {
    closeAll(null);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAll(null);
  });

  function start() {
    if (build()) return;
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (build() || tries > 24) clearInterval(timer);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function () {
    setTimeout(start, 300);
  });
})();
